import { render, staticRenderFns } from "./PendingProductComment.vue?vue&type=template&id=603fd69a"
import script from "./PendingProductComment.vue?vue&type=script&lang=js"
export * from "./PendingProductComment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports